import { INVOICE_PAYMENT_FAIL_PROPOSAL_STRIPE_ATTEMPT_API_ROUTE } from '~/routes/remix-api.invoice-payment-fail-proposal-stripe-attempt';
import { INVOICE_PAYMENT_PENDING_PROPOSAL_STRIPE_ATTEMPT_API_ROUTE } from '~/routes/remix-api.invoice-payment-pending-proposal-stripe-attempt';

/**
 * Creates a pending Stripe attempt before Stripe.js confirms a PaymentIntent on the proposal page.
 */
export async function postPendingProposalStripeAttempt(
    invoicePaymentId: number,
    stripePaymentIntentId?: string | null,
): Promise<void> {
    const formData = new FormData();
    formData.append('invoicePaymentId', String(invoicePaymentId));
    if (stripePaymentIntentId) {
        formData.append('stripePaymentIntentId', stripePaymentIntentId);
    }

    await fetch(INVOICE_PAYMENT_PENDING_PROPOSAL_STRIPE_ATTEMPT_API_ROUTE, {
        method: 'POST',
        body: formData,
    });
}

/**
 * Sync-fails the active proposal Stripe attempt after Stripe.js reports a card decline.
 */
export async function postFailProposalStripeAttempt(
    invoicePaymentId: number,
    stripePaymentIntentId?: string | null,
    failureReason?: string | null,
): Promise<void> {
    const formData = new FormData();
    formData.append('invoicePaymentId', String(invoicePaymentId));
    if (stripePaymentIntentId) {
        formData.append('stripePaymentIntentId', stripePaymentIntentId);
    }
    if (failureReason) {
        formData.append('failureReason', failureReason);
    }

    await fetch(INVOICE_PAYMENT_FAIL_PROPOSAL_STRIPE_ATTEMPT_API_ROUTE, {
        method: 'POST',
        body: formData,
    });
}
